export default __webpack_public_path__ + "static/media/icon_search-anchor-olive.6a95dfc4.svg";